<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <ninja-keys
    ref="ninjakeys"
    :no-auto-load-md-icons="true"
    hideBreadcrumbs
    :placeholder="placeholder"
    @selected="onSelected"
  />
</template>

<script>
import 'ninja-keys';
import conversationHotKeysMixin from './conversationHotKeys';
import goToCommandHotKeys from './goToCommandHotKeys';
import appearanceHotKeys from './appearanceHotKeys';
import agentMixin from 'dashboard/mixins/agentMixin';
import conversationLabelMixin from 'dashboard/mixins/conversation/labelMixin';
import conversationTeamMixin from 'dashboard/mixins/conversation/teamMixin';
import adminMixin from 'dashboard/mixins/isAdmin';
import { GENERAL_EVENTS } from '../../../helper/AnalyticsHelper/events';

export default {
  mixins: [
    adminMixin,
    agentMixin,
    conversationHotKeysMixin,
    conversationLabelMixin,
    conversationTeamMixin,
    appearanceHotKeys,
    goToCommandHotKeys,
  ],
  computed: {
    placeholder() {
      return this.$t('COMMAND_BAR.SEARCH_PLACEHOLDER');
    },
    accountId() {
      return this.$store.getters.getCurrentAccountId;
    },
    routeName() {
      return this.$route.name;
    },
    hotKeys() {
      return [
        ...this.conversationHotKeys,
        ...this.goToCommandHotKeys,
        ...this.goToAppearanceHotKeys,
      ];
    },
  },
  watch: {
    routeName() {
      this.setCommandbarData();
    },
  },
  mounted() {
    this.setCommandbarData();
  },
  methods: {
    setCommandbarData() {
      this.$refs.ninjakeys.data = this.hotKeys;
    },
    onSelected(item) {
      const { detail: { action: { title = null, section = null } = {} } = {} } =
        item;
      this.$track(GENERAL_EVENTS.COMMAND_BAR, {
        section,
        action: title,
      });
      this.setCommandbarData();
    },
  },
};
</script>

<style lang="scss">
ninja-keys {
  // Was `var(--w-500)` — Chatwoot's blue. This palette is opened dozens of times a day and was
  // the one surface still arriving in the vendor's colour.
  --ninja-accent-color: oklch(var(--accent-mint));
  --ninja-font-family: 'Outfit', 'IBM Plex Sans Arabic';
  z-index: 9999;
}

// Wrapped with body.dark to avoid overriding the default theme
// If OS is in dark theme and app is in light mode, It will prevent showing dark theme in command bar
body.dark {
  ninja-keys {
    // Every value here was a hardcoded neutral grey — a grey modal in a navy product — and the
    // two text colours were near-pure white, which the brand forbids. Tokens throughout, so it
    // sits on the same ground as everything behind it.
    --ninja-overflow-background: oklch(var(--brand-ink) / 0.6);
    --ninja-modal-background: oklch(var(--slate-800));
    --ninja-secondary-background-color: oklch(var(--slate-700));
    --ninja-selected-background: oklch(var(--slate-700));
    --ninja-footer-background: oklch(var(--slate-800));
    --ninja-text-color: oklch(var(--slate-25));
    --ninja-icon-color: oklch(var(--slate-100));
    --ninja-secondary-text-color: oklch(var(--slate-300));
  }
}
</style>
